var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t(_vm.isEditing ? "Cuona.Event.change" : "Cuona.Event.new"),
        width: "65%",
        top: "8vh",
        visible: _vm.isShowingDialog,
      },
      on: { closed: _vm.dialogClosed, close: _vm.hideDialog },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoadingEvent,
              expression: "isLoadingEvent",
            },
          ],
          ref: "dialogForm",
          attrs: {
            "label-position": "left",
            rules: _vm.rules,
            "label-width": "140px",
            model: _vm.dialogForm,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Cuona.Event.name"), prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.dialogForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.dialogForm, "name", $$v)
                  },
                  expression: "dialogForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("Cuona.Event.action"),
                prop: "actionType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "action",
                  attrs: {
                    placeholder: _vm.$t("Cuona.Event.choice"),
                    disabled: _vm.isEditing,
                  },
                  model: {
                    value: _vm.dialogForm.actionType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dialogForm, "actionType", $$v)
                    },
                    expression: "dialogForm.actionType",
                  },
                },
                _vm._l(_vm.availableActions, function (action) {
                  return _c("el-option", {
                    key: action.type,
                    attrs: { label: _vm.$t(action.name), value: action.type },
                  })
                }),
                1
              ),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "right",
                    title: _vm.setActionTitle(),
                    width: "200",
                    trigger: "hover",
                    content: _vm.setContent(),
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "question",
                      attrs: { slot: "reference", type: "text" },
                      slot: "reference",
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.dialogForm.actionType === "checkin" ||
          _vm.dialogForm.actionType === "checkout"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("WebHook.enabled") } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.webhookSettings.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.webhookSettings, "enabled", $$v)
                      },
                      expression: "webhookSettings.enabled",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dialogForm.actionType === "public_url" ||
          _vm.dialogForm.actionType === "custom_url"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Cuona.Event.url_txt") } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "space-between" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("Cuona.Event.placeholderUrl"),
                            },
                            model: {
                              value: _vm.dialogForm.actionData.url,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm.actionData, "url", $$v)
                              },
                              expression: "dialogForm.actionData.url",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: _vm.checkUrlLength() },
                              on: { click: _vm.insertDeviceId },
                            },
                            [_vm._v("固有IDを挿入")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.webhookSettings.enabled
            ? _c("web-hook-setting-form", {
                model: {
                  value: _vm.webhookSettings,
                  callback: function ($$v) {
                    _vm.webhookSettings = $$v
                  },
                  expression: "webhookSettings",
                },
              })
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Cuona.Event.note") } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 2 },
                model: {
                  value: _vm.dialogForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.dialogForm, "description", $$v)
                  },
                  expression: "dialogForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Cuona.Event.group"), prop: "group" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "group-select",
                  attrs: {
                    placeholder: _vm.$t("Cuona.Event.choice"),
                    multiple: "",
                  },
                  model: {
                    value: _vm.dialogForm.selectedGroupIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.dialogForm, "selectedGroupIds", $$v)
                    },
                    expression: "dialogForm.selectedGroupIds",
                  },
                },
                _vm._l(_vm.groups, function (group, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: group.name, value: group.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "CUONA" } }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-table",
                  {
                    ref: "groupDeviceTable",
                    attrs: {
                      data: _vm.devices,
                      "cell-class-name": "el-table-cell",
                      "row-class-name": "el-table-row",
                      "max-height": "300",
                      "empty-text": "",
                    },
                    on: {
                      "row-click": _vm.toggleDevice,
                      "selection-change": _vm.setSelectedDevices,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: _vm.$t("Cuona.Device.name"),
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("img", {
                                staticClass: "device-image",
                                attrs: { src: _vm.getCuonaImage(props.row) },
                              }),
                              _c("span", [_vm._v(_vm._s(props.row.name))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180px",
                        prop: "nfc_uid",
                        label: _vm.$t("Cuona.Device.id"),
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "groups",
                        label: _vm.$t("Cuona.Event.group"),
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._l(props.row.groups, function (group) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      staticClass: "tag",
                                      attrs: { size: "mini" },
                                    },
                                    [_vm._v(_vm._s(group.name))]
                                  ),
                                ]
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.isLoadingEvent },
              on: { click: _vm.hideDialog },
            },
            [_vm._v(_vm._s(_vm.$t("Cuona.Event.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isLoadingEvent },
              on: { click: _vm.createUpdateEvent },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    _vm.isEditing ? "Cuona.Event.update" : "Cuona.Event.create"
                  )
                )
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }